
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-c2403f8a\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ReviewerSettingDialog.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewerSettingDialog.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c2403f8a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewerSettingDialog.vue"),
  /* scopeId */
  "data-v-c2403f8a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/developerInfo/components/ReviewerSettingDialog.vue
// module id = 2399
// module chunks = 68